import styled from "@emotion/styled";
import UplaodImageIcon from "@mui/icons-material/AddCircle";
import { Box, Button } from "@mui/material";

export const AuthorizedInfoWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ProfileImageWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

export const UploadImageButton = styled(Button)`
  max-width: 100px;
  width: 100%;
  position: relative;
  cursor: pointer;
  &:hover {
    background-color: unset;
  }
  .avatar {
    width: 80px;
    height: 80px;
  }
`;

export const PlusIcon = styled(UplaodImageIcon)`
  position: absolute;
  top: 65%;
  right: 13%;
`;
